function NewsController(){
	this.className	= "NewsController";
	this.glob		= "/news**";
	this.debug		= false;
};
NewsController.inheritsFrom( StandardController );
NewsController.prototype.swap = function(onComplete){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
	this.$latestNews 		= $('.js-latest-article');
	this.$moreArticlesButton = $('.js-more-articles-button');
	this.$loadingArticlesMessage = $('.js-loading-articles-message');
	this.$articlesContainer = document.querySelector('.articles');
	
	this.articlesPagination = 0;

	this.imageController = Aviator.get('baseController').imageController;
	this.imageController.addListener("loaded-size", e => this.imageLoaded(e));

	this.$moreArticlesButton.on('click', Igloo.delegate(this, this.loadMoreArticles));

	/*
	var readMore = Igloo.delegate(this,function(){
		this.readMores = ReadMore.build({
			$wrapper: 	this.$latestNews,
			content: 	".js-content",
			text: 		".js-reduce",
			// maxHeight: 	25,
			dynamic:	true,
		});
	});
	readMore();
	*/

	//return false;
};
NewsController.prototype.on = function(){
	console.log("on");
	this.$leftNewsImage = this.$page.find('.inherited-replace-left');
	console.log(this.$leftNewsImage);
	this.resizeDelegate = jstage.addListener("resize", Igloo.delegate(this,this.onResize));
	this.onResize();
}
NewsController.prototype.imageLoaded = function(e){
	console.log(e);
	const $img = e.size.$img.closest('.inherited-replace-left');
	this.calculateImageOffset($img);
}
NewsController.prototype.calculateImageOffset = function($img){
	if($img.length){
		const offset = $img.width() / 2 * -1;
		$img.css({'marginLeft': offset});
	}
}
NewsController.prototype.onResize = function(){
	const $img = this.$leftNewsImage;
	$img.each(Igloo.$delegate(this, function($this){
		this.calculateImageOffset($this);
	}));
}
NewsController.prototype.off = function(){
	if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
	// if(this.readMores) this.readMores.destroy();
};
NewsController.prototype.loadMoreArticles = async function() {
	
	this.$moreArticlesButton.toggleClass('hide');
	this.$loadingArticlesMessage.toggleClass('hide');

	this.articlesPagination++;
	const newArticles = await this.ajax({
		articlesPagination: this.articlesPagination,
	});
	if (newArticles) {
		newArticles.forEach((newArticle, newArticleIndex) => {
			this.addArticleToDom(newArticle, newArticleIndex);

			if (newArticleIndex === 0) {
				$('html, body').animate({
					scrollTop: $("article:last-child").offset().top - 30
				}, 500);
			}

		});	
	} else {
		this.$moreArticlesButton.hide();
	}
	// console.log(newArticles);
}
NewsController.prototype.ajax = async function(data) {
  return $.ajax({
    url: '/news/more',
    data: data,
    method: "post"
  }).then(result => {
		const json = JSON.parse(result);
		const items = json['articles'];
		
		this.$moreArticlesButton.toggleClass('hide');
		this.$loadingArticlesMessage.toggleClass('hide');

		if(!json['has_more_articles']) this.$moreArticlesButton.hide();
		
		// jcache.clearCache();
    return items;
  })
}
NewsController.prototype.addArticleToDom = function(articleData) {

	const article = document.createElement('article');
	this.$articlesContainer.appendChild(article);
	article.className = 'news-item cont-12 mb-4 mb-sm-0';

	const detailsColumn = document.createElement('div');
	article.appendChild(detailsColumn);
	detailsColumn.className = 'col-12 col-sm-9 col-md-9 mb-1 mb-sm-3';

	const dateBlock = document.createElement('div');
	dateBlock.className = 'col-12 col-sm-3 col-md-2 pleft-lg-0-5 mb-1 mb-sm-2';
	detailsColumn.appendChild(dateBlock);

	const date = document.createElement('time');
	dateBlock.appendChild(date);
	date.dateTime = articleData.published;
	date.innerHTML = articleData.date_long;

	const titleBlock = document.createElement('div');
	detailsColumn.appendChild(titleBlock);
	titleBlock.className = 'col-12 col-sm-9 col-md-5 mb-1 mb-sm-1-5';

	const title = document.createElement('h1');
	titleBlock.appendChild(title);
	title.className = "f-title-large";
	title.innerHTML = articleData.title;

	const descriptionBlock = document.createElement('div');
	detailsColumn.appendChild(descriptionBlock);
	descriptionBlock.className = 'col-12 col-sm-5 left-md-2 description';

	const description = document.createElement('div');
	descriptionBlock.appendChild(description);
	description.innerHTML = articleData.excerpt;

	const buttonColumn = document.createElement('div');
	article.appendChild(buttonColumn);
	buttonColumn.className = 'col-12 col-sm-3 col-md-3';
	
	const button = document.createElement('a');
	buttonColumn.appendChild(button);	
	button.className = "button colour-secondary auto-link";
	button.href = articleData.link;
	button.innerHTML = 'Read more';

	const buttonBackground = document.createElement('div');
	button.appendChild(buttonBackground);
	buttonBackground.className = "button-background";
	
}